const Allstar = {
  dateNow: '24.08.2020',
  saved: true,
  games: [],
  inputValue: '',
  namePosition: [
    { name: 'Ronaldo', position: 'ЛН' },
    { name: 'Maradona', position: 'ПН' },
    { name: 'Ronaldinho', position: 'ПЗ' },
    { name: 'Zidane', position: 'ЛЗ' },
    { name: 'Yashin', position: 'ВР' },
    { name: 'Tikhonov', position: 'ЗАМ1' },
    { name: 'Baggio', position: 'ЗАМ3' },
    { name: 'C.Ronaldo', position: 'ЗАМ2' },
    { name: 'Messi', position: 'ЗАМ4' },
  ],
  players: [
    'Ronaldo',
    'Maradona',
    'Ronaldinho',
    'Zidane',
    'Tikhonov',
    'Yashin',
    'Baggio',
    'C.Ronaldo',
    'Messi',
  ],
  playersPosition: [],
  team: 'All-Star',
  inputValueStartPage: '',
  date: [],
  result: '20-1',
  opponent: 'Anyone',
  playersCounter: true,
  playerNameControl: false,
  playerNameControlLength: false,
  Ronaldo: ['ЛН', 3],
  Maradona: ['ПН', 4],
  Ronaldinho: ['ПЗ', 2],
  Zidane: ['ЛЗ', 2],
  Yashin: ['ВР', -1],
  Tikhonov: ['ЗАМ1', 2],
  Messi: ['ЗАМ4', 2],
  Baggio: ['ЗАМ3', 2],
  'C.Ronaldo': ['ЗАМ2', 3],
};
export default Allstar;
